import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomButton from './CustomButton';

interface LogoutConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function LogoutConfirmationModal({
  open,
  onClose,
  onConfirm,
}: LogoutConfirmationModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="logout-dialog-title"
      aria-describedby="logout-dialog-description"
      PaperProps={{
        sx: { minWidth: { xs: '90%', sm: 400 } },
      }}
    >
      <DialogTitle id="logout-dialog-title">{t('app.logoutConfirmTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="logout-dialog-description">
          <Typography color="text.secondary">{t('app.logoutConfirmMessage')}</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 0, justifyContent: 'center' }}>
        <CustomButton onClick={onClose} variant="secondary">
          {t('common.cancel')}
        </CustomButton>
        <CustomButton onClick={onConfirm} variant="primary">
          {t('app.confirmLogout', { defaultValue: 'Sair Agora' })}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}
